/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessoryCategory } from '../models/AccessoryCategory';
import type { BandSelectorCatalog } from '../models/BandSelectorCatalog';
import type { JoinDevicesAndTiers } from '../models/JoinDevicesAndTiers';
import type { MembershipCatalog } from '../models/MembershipCatalog';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class JoinCatalogResourceV2Service {

    /**
     * getAccessories
     * Gets products that should be displayed on the join flow accessories page, filtered by device, tier, and localization
     * @returns AccessoryCategory Returns section of catalog of only products that should be displayed on the accessories page
     * @throws ApiError
     */
    public static getAccessories({
        device,
        country,
        language,
        promoCode,
        tier,
    }: {
        device: 'UNKNOWN' | 'KENMORE' | 'COPLEY' | 'HARVARD' | 'GOOSE' | 'MAVERICK',
        country: string,
        language: string,
        promoCode?: string,
        tier?: 'ONE' | 'PEAK' | 'LIFE',
    }): CancelablePromise<Array<AccessoryCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/join-flow/catalog/accessories',
            query: {
                'device': device,
                'country': country,
                'language': language,
                'promoCode': promoCode,
                'tier': tier,
            },
            errors: {
                500: `Server error`,
            },
        });
    }

    /**
     * getBands
     * Gets products that should be displayed on the band selection page, filtered by tier, localization, and device
     * @returns BandSelectorCatalog Returns section of catalog of only products that should be displayed with the band selector
     * @throws ApiError
     */
    public static getBands({
        device,
        country,
        language,
        tier,
        promoCode,
    }: {
        device: 'UNKNOWN' | 'KENMORE' | 'COPLEY' | 'HARVARD' | 'GOOSE' | 'MAVERICK',
        country: string,
        language: string,
        tier?: 'ONE' | 'PEAK' | 'LIFE',
        promoCode?: string,
    }): CancelablePromise<BandSelectorCatalog> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/join-flow/catalog/bands',
            query: {
                'device': device,
                'country': country,
                'language': language,
                'tier': tier,
                'promoCode': promoCode,
            },
            errors: {
                500: `Server error`,
            },
        });
    }

    /**
     * getDevicesAndTiers
     * Gets devices and tiers that should be displayed on the OPL page, based on the country and language
     * @returns JoinDevicesAndTiers Returns section of catalog of only products that should be displayed with the membership page
     * @throws ApiError
     */
    public static getDevicesAndTiers1({
        country,
        language,
        promoCode,
    }: {
        country: string,
        language: string,
        promoCode?: string,
    }): CancelablePromise<JoinDevicesAndTiers> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/join-flow/catalog/devices-tiers',
            query: {
                'country': country,
                'language': language,
                'promoCode': promoCode,
            },
            errors: {
                500: `Server error`,
            },
        });
    }

    /**
     * getMemberships
     * Gets products that should be displayed on the membership page, filtered by tier
     * @returns MembershipCatalog Returns section of catalog of only products that should be displayed with the membership page
     * @throws ApiError
     */
    public static getMemberships({
        tier,
        country,
        language,
        promoCode,
    }: {
        tier: 'ONE' | 'PEAK' | 'LIFE',
        country: string,
        language: string,
        promoCode?: string,
    }): CancelablePromise<MembershipCatalog> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/join-flow/catalog/memberships',
            query: {
                'tier': tier,
                'country': country,
                'language': language,
                'promoCode': promoCode,
            },
            errors: {
                500: `Server error`,
            },
        });
    }

}
